import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { PopUpView } from '~/components';

export default function Spinner({ isRelative, isOpen, ...rest }) {
  if (isRelative) {
    if (!isOpen) return null;
    return (
      <S.SpinnerContainer {...rest}>
        <S.OpacityLayer />
        <S.Spinner />
      </S.SpinnerContainer>
    );
  }
  return (
    <PopUpView isOpen={isOpen} zone="whole" fullWidth>
      <S.Spinner {...rest} />
    </PopUpView>
  );
}

Spinner.propTypes = {
  isRelative: PropTypes.bool,
  isOpen: PropTypes.bool,
};

Spinner.defaultProps = {
  isRelative: false,
  isOpen: false,
};
